import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import { CategoryTopic } from 'src/interface';
import { ButtonBorderTabCategory } from '../Forms/Button';
import classes from './TabMenuCategoryNew.module.less';
type Props = {
  activeKeyCategory: any;
  handleChangeCategory: (category: CategoryTopic) => void;
  categoryTopics: CategoryTopic[];
  keyTopic: any;
};
const TabMenuCategoryNew = (props: Props) => {
  const {
    xs
  } = Grid.useBreakpoint();
  const {
    categoryTopics,
    keyTopic,
    handleChangeCategory
  } = props;
  const [selectCategory, setSelectedCategory] = useState<any>([]);
  const router = useRouter();
  const onChangeCategory = (selectedKey: any) => {
    setSelectedCategory(selectedKey.slug);
    router.push(`/artikel/${router.query.phase}/${router.query.group}/${selectedKey.slug}`);
    handleChangeCategory(selectedKey);
  };
  const tabsRef = useRef<HTMLDivElement>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const scrollLeftBtn = () => {
    const tabs = tabsRef.current;
    if (!tabs) return;
    const scrollAmount = window.innerWidth < 768 ? 150 : 250;
    tabs.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  };
  const scrollRightBtn = () => {
    const tabs = tabsRef.current;
    if (!tabs) return;
    const scrollAmount = window.innerWidth < 768 ? 150 : 250;
    tabs.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  };
  const checkOverflow = () => {
    const tabs = tabsRef.current;
    if (!tabs) return;
    const {
      scrollLeft,
      scrollWidth,
      clientWidth
    } = tabs;
    setShowLeftArrow(scrollLeft > 10);
    setShowRightArrow(scrollWidth > clientWidth && scrollLeft < scrollWidth - clientWidth - 10);
  };
  useEffect(() => {
    checkOverflow();
    setSelectedCategory(router.query.category);
    const dCat = router?.query?.category;
    Cookies.set('dCat', dCat || '', {
      expires: 1
    });
  }, [categoryTopics, keyTopic]);
  useEffect(() => {
    const tabs = tabsRef.current;
    if (!tabs) return;
    const handleScroll = () => checkOverflow();
    tabs.addEventListener('scroll', handleScroll);
    checkOverflow();
    return () => {
      tabs.removeEventListener('scroll', handleScroll);
    };
  }, []);
  if (!categoryTopics || categoryTopics.length === 0) {
    return <div className={classes.paragraph}>category sedang dicari, tunggu sebentar ya ma ...</div>;
  }
  const staticTab = {
    slug: 'buat-mama',
    name: 'Buat Mama',
    media_images: {
      original: '/images/artikel/buat-mama.svg'
    },
    title: ''
  };
  const allTabs = [staticTab, ...(props.categoryTopics || [])];
  return <div className={classes.wrapper}>
			<div ref={tabsRef} className={classes.tabs}>
				{allTabs?.map((categoryTopic: any, id: number) => {
        const key = `${id + 1}__${categoryTopic.slug}`;
        const keys = `${categoryTopic.slug}`;
        const isActiveKey = keys === selectCategory;
        return <div key={key} className={classNames(classes.tab, {
          [classes.active]: isActiveKey
        })}>
							<a href={`/artikel/${router.query.phase}/${router.query.group}/${categoryTopic.slug}`} id={'artikel-' + categoryTopic.slug}>
								<ButtonBorderTabCategory style={{
              backgroundColor: isActiveKey ? '#FDECEC' : 'white',
              color: isActiveKey ? '#F36D6D' : '#BFAFAF',
              cursor: 'pointer',
              borderRadius: '21px',
              borderColor: isActiveKey ? '#F36D6D' : '#BFAFAF'
            }} text={categoryTopic?.name} image={categoryTopic?.media_images?.original} onClick={() => onChangeCategory(categoryTopic)} />
							</a>
						</div>;
      })}

				{xs ? '' : <>
					<button className={classNames(classes['scroll-arrow-left'], {
          [classes.visible]: showLeftArrow
        })} onClick={scrollLeftBtn} aria-label="Scroll ke kiri" type="button">
						<LeftOutlined style={{
            fontSize: '14px',
            color: '#4A4545'
          }} />
					</button>
					<button className={classNames(classes['scroll-arrow-right'], {
          [classes.visible]: showRightArrow
        })} onClick={scrollRightBtn} aria-label="Scroll ke kanan" type="button">
						<RightOutlined style={{
            fontSize: '14px',
            color: '#4A4545'
          }} />
					</button>
				</>}
			</div>
		</div>;
};
export default TabMenuCategoryNew;